import { render, staticRenderFns } from "./AssignmentStatusSelect.vue?vue&type=template&id=4d2e8526&"
import script from "./AssignmentStatusSelect.vue?vue&type=script&lang=js&"
export * from "./AssignmentStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports